import React, {createContext} from "react";
import {DutyManagerReportFormErrors} from "../../../../../../utils/formUtils";

export const DutyManagerReportFormErrorsContext =
    createContext<DutyManagerReportFormErrorsContextType>(
        {} as DutyManagerReportFormErrorsContextType
    );

export const DutyManagerReportFormErrorsContextDefaultValue = {
    rate: {valid: true, messages: []},
    valid: function () {
        return this.rate.valid;
    },
    messages: function () {
        return this.rate.messages;
    }
};

interface DutyManagerReportFormErrorsContextType {
    formErrors: DutyManagerReportFormErrors;
    setFormErrors: React.Dispatch<React.SetStateAction<DutyManagerReportFormErrors>>;
}
